/**
 * Shopify Theme Snippet: GA4 client_id → Checkout Order Attribute
 *
 * Dieses Snippet in theme.liquid vor </body> einfügen (oder als separates
 * Snippet auslagern und per {% render %} einbinden).
 *
 * Es liest die GA4 client_id aus dem _ga Cookie und speichert sie als
 * Order Note Attribute. Der Cloudflare Worker liest sie beim Webhook aus,
 * damit der server-seitige Purchase-Event mit der Browser-Session gemergt wird.
 */

(function () {
  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  }

  const ga = getCookie("_ga");
  if (!ga) return;

  // _ga format: GA1.2.XXXXXXXXXX.YYYYYYYYYY
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes: { ga_client_id: ga },
    }),
  }).catch(function () {
    // Stille Fehler — kein User-Impact
  });
})();
